
import React from 'react';
import MetricCard from '../MetricCard';

interface LeadsCardProps {
  nonDisqualifiedLeads: number;
  timeFrame?: string;
  noData?: boolean;
}

const LeadsCard: React.FC<LeadsCardProps> = ({ 
  nonDisqualifiedLeads, 
  timeFrame = 'Past 30 days',
  noData = false
}) => {
  // For the progress bar to show gold-green at 100%, we need to not provide a custom progressColor
  const tooltipText = `A contact counts as a lead as long as it's outcome is not disqualified (${timeFrame})`;
  
  return (
    <MetricCard 
      title="Leads"
      value={nonDisqualifiedLeads.toString()} 
      tooltip={tooltipText}
      min={0} 
      max={23} 
      current={nonDisqualifiedLeads} 
      hideMinLabel={true}
      noData={noData}
    />
  );
};

export default LeadsCard;
